const dict = {
  "nav_group_overview": "Panoramica",
  "nav_group_sales": "Vendite",
  "nav_group_customers": "Clienti",
  "nav_group_service": "Servizio e Qualità",
  "nav_group_contracts": "Contratti",
  "nav_group_operations": "Operazioni",
  "nav_group_insights": "Analisi",
  "nav_group_ki": "IA",
  "nav_group_purchasing": "Acquisti",
  "nav_sub_suppliers": "Fornitori",
  "nav_sub_procurement": "Approvvigionamento",
  "nav_sub_quality": "Qualità",
  "nav_sub_analytics": "Analisi e risparmi",
  "nav_sub_governance": "Governance e sistemi",
  "ki_menu": "Menu IA",
  "ki_costs": "Costi IA",
  "quote_comparison": "Confronto offerte IA",
  "my_access": "I miei diritti",
  "my_accounts_rights": "I miei clienti e diritti",
  "my_role": "Ruolo / profilo",
  "visible_accounts": "Clienti visibili",
  "all_accounts_visible": "Puoi vedere tutti i clienti",
  "active_grants": "Autorizzazioni temporanee attive",
  "no_grants": "Nessuna autorizzazione temporanea",
  "access_scope": "Ambito di accesso",
  "field_permissions": "Permessi di campo",
  "roles_rights": "Ruoli e diritti",
  "reassign": "Riassegna",
  "responsible_reps": "Commerciali responsabili",
  "assignment_history": "Storico assegnazioni",
  "changed_by": "Modificato da",
  "effective_date": "Data effettiva",
  "bulk_assign": "Assegnazione massiva",
  "add_grant": "Aggiungi autorizzazione",
  "grant_type": "Tipo",
  "deputy": "Sostituzione / ferie",
  "exception": "Eccezione",
  "valid_from": "Valido dal",
  "valid_to": "Valido fino al",
  "reason": "Motivo",
  "access_log": "Registro accessi",
  "access_deputy": "Accesso e sostituzione",
  "restricted_account": "Limitato — solo dati di base",
  "restricted_hint": "Non sei assegnato a questo cliente. I dati commerciali sono nascosti.",
  "role_profile": "Profilo di ruolo",
  "account_visibility": "Visibilità clienti",
  "vis_all": "Tutti i clienti",
  "vis_assigned": "Solo assegnati",
  "vis_team": "Assegnati + team",
  "unassigned_view": "Clienti non assegnati",
  "unassigned_hidden": "Nascosto",
  "unassigned_basic": "Solo dati di base",
  "see_revenue_qty": "Fatturato / quantità",
  "see_wallet": "Wallet Share e concorrenza",
  "see_visit_notes": "Note di visita",
  "see_web_research": "Ricerca esterna",
  "see_ai_analysis": "Analisi cliente (IA)",
  "can_reassign": "Può riassegnare clienti",
  "grants_deputy_help": "Accesso temporaneo ai clienti di un collega (es. sostituzione per ferie). Scade automaticamente.",
  "manager": "Riporta a (Team Lead)",
  "key_accounts": "Key Account strategici",
  "no_access": "Nessun accesso",
  "mode_replace": "Sostituisci",
  "mode_add": "Aggiungi all'esistente",
  "select_accounts": "Seleziona clienti",
  "user": "Utente",
  "dashboard": "Dashboard",
  "accounts": "Clienti",
  "contacts": "Contatti",
  "leads": "Leads",
  "opportunities": "Opportunità",
  "quotes": "Offerte",
  "complaints": "Reclami",
  "admin": "Amministrazione",
  "admin_settings": "Impostazioni",
  "search_placeholder": "Cerca clienti, contatti, opportunità…",
  "new": "Nuovo",
  "logout": "Esci",
  "notifications": "Notifiche",
  "mark_all_read": "Segna tutto come letto",
  "no_notifications": "Nessuna notifica",
  "save": "Salva",
  "cancel": "Annulla",
  "delete": "Elimina",
  "edit": "Modifica",
  "create": "Crea",
  "close": "Chiudi",
  "export_csv": "Esporta CSV",
  "import_csv": "Importa CSV",
  "records": "record",
  "actions": "Azioni",
  "name": "Nome",
  "company": "Azienda",
  "account": "Cliente",
  "owner": "Referente",
  "status": "Stato",
  "stage": "Fase",
  "amount": "Importo",
  "probability": "Probabilità",
  "segment": "Segmento",
  "segments": "Segmenti",
  "add": "Aggiungi",
  "segments_help": "Gestisci l'elenco dei segmenti per clienti e stabilimenti. Rinominare aggiorna tutti i record assegnati.",
  "segment_name": "Nome del segmento",
  "segment_renamed": "Segmento rinominato ✓",
  "segment_deleted": "Segmento eliminato ✓",
  "type": "Tipo",
  "email": "E-mail",
  "phone": "Telefono",
  "mobile": "Cellulare",
  "title_field": "Ruolo",
  "department": "Reparto",
  "buying_role": "Ruolo nel buying center",
  "source": "Origine",
  "score": "Score",
  "severity": "Gravità",
  "defect_category": "Categoria del difetto",
  "claimed_value": "Valore reclamato",
  "date_received": "Data di ricezione",
  "sla": "SLA",
  "overdue": "Scaduto",
  "convert": "Converti",
  "converted": "Convertito",
  "product_type": "Tipo di prodotto",
  "print_technology": "Tecnologia di stampa",
  "substrate": "Substrato / materiale",
  "finishing": "Finitura",
  "business_type": "Tipo di business",
  "competitors": "Concorrenti",
  "close_reason": "Motivo vinto/perso",
  "close_date": "Chiusura prevista",
  "annual_volume": "Volume annuo",
  "num_skus": "N° SKU",
  "num_colors": "N° colori",
  "abc_class": "Classe ABC",
  "annual_spend": "Spesa annua etichette",
  "payment_terms": "Condizioni di pagamento",
  "incoterm": "Incoterm",
  "credit_limit": "Limite di credito",
  "vat_id": "P.IVA",
  "city": "Città",
  "billing_address": "Indirizzo di fatturazione",
  "customer_since": "Cliente dal",
  "certifications": "Certificazioni",
  "region": "Regione",
  "parent_account": "Società madre",
  "kanban": "Kanban",
  "table": "Tabella",
  "weighted_forecast": "Forecast ponderato",
  "aging_alert": "Nessuna attività da 14+ giorni",
  "total_pipeline": "Pipeline totale",
  "weighted_pipeline": "Pipeline ponderata",
  "win_rate": "Win Rate",
  "avg_deal": "Dimensione media trattativa",
  "open_opps": "Opportunità aperte",
  "pipeline_by_stage": "Pipeline per fase",
  "forecast_by_month": "Forecast per mese",
  "forecast_by_rep": "Forecast per commerciale",
  "revenue_by_segment": "Fatturato per segmento",
  "top_opportunities": "Top 10 opportunità",
  "open_complaints": "Reclami aperti",
  "critical": "Critico",
  "sla_compliance": "Rispetto SLA",
  "avg_resolution": "Giorni medi di risoluzione",
  "pareto": "Reclami per categoria (Pareto)",
  "trend_12m": "Trend reclami",
  "by_severity": "Aperti per gravità",
  "top_accounts_complaints": "Top 5 clienti per valore reclami",
  "revenue_ytd": "Fatturato YTD",
  "vs_py": "vs. anno precedente",
  "abc_distribution": "Distribuzione ABC clienti",
  "churn_risk": "Clienti a rischio abbandono",
  "business_split": "Nuovo business vs. rinnovo",
  "sales_dash": "Vendite",
  "quality_dash": "Qualità",
  "management_dash": "Direzione",
  "comments": "Commenti",
  "audit_trail": "Storico modifiche",
  "add_comment": "Aggiungi un commento…",
  "post": "Invia",
  "quote_number": "N° offerta",
  "validity": "Valida fino al",
  "total": "Totale",
  "margin": "Margine",
  "version": "Versione",
  "revise": "Nuova versione",
  "download_pdf": "Scarica PDF",
  "line_items": "Voci",
  "material": "Materiale",
  "width": "Larghezza",
  "height": "Altezza",
  "quantity": "Quantità",
  "unit_price": "Prezzo/1000",
  "tooling": "Attrezzaggio",
  "cost": "Costo/1000",
  "line_total": "Totale voce",
  "add_line": "Aggiungi voce",
  "price_breaks": "Prezzi a scaglioni",
  "winding": "Avvolgimento",
  "core_size": "Anima",
  "labels_per_roll": "Etichette/rotolo",
  "d8_report": "Report 8D",
  "claimed_qty": "Quantità reclamata",
  "accepted_value": "Valore accettato",
  "credit_note": "N° nota di credito",
  "order_number": "N° ordine",
  "article_number": "N° articolo",
  "received_via": "Ricevuto via",
  "costs": "Costi del reclamo",
  "cost_credit": "Nota di credito",
  "cost_reprint": "Ristampa",
  "cost_freight": "Trasporto",
  "save_costs": "Salva costi",
  "delete_file_confirm": "Eliminare questo file?",
  "contact": "Contatto",
  "users": "Utenti",
  "picklists": "Liste di selezione",
  "role": "Ruolo",
  "territory": "Territorio",
  "password": "Password",
  "add_user": "Crea utente",
  "tags": "Tag",
  "info": "Dettagli",
  "hierarchy": "Gerarchia",
  "children_accounts": "Filiali",
  "open_opp_value": "Valore opportunità aperte",
  "avg_margin": "Margine medio",
  "estimated_volume": "Volume annuo stimato",
  "product_interest": "Interesse di prodotto",
  "possible_duplicate": "Possibile duplicato trovato",
  "login_title": "Accedi a Encasa",
  "login_sub": "CRM e SRM per produttori di imballaggi",
  "recently_viewed": "Visti di recente",
  "no_results": "Nessun risultato",
  "loading": "Caricamento…",
  "empty_title": "Ancora niente qui",
  "empty_cta": "Crea il tuo primo record per iniziare",
  "all_stages": "Tutte le fasi",
  "all": "Tutti",
  "required_close_reason": "Seleziona il motivo della chiusura",
  "mark_won": "Vinta",
  "mark_lost": "Persa",
  "quality": "Qualità",
  "engagement": "Coinvolgimento (0-30)",
  "linkedin": "LinkedIn",
  "preferred_language": "Lingua preferita",
  "birthday": "Compleanno",
  "notes": "Note",
  "shipping_addresses": "Indirizzi di spedizione",
  "trade_fair": "Fiera",
  "activities": "Attività",
  "calendar": "Calendario",
  "list_view": "Elenco",
  "due_date": "Scadenza",
  "priority": "Priorità",
  "subject": "Oggetto",
  "date": "Data",
  "time": "Ora",
  "activity_type": "Tipo",
  "done": "Completato",
  "open_status": "Aperto",
  "visit_report": "Report di visita",
  "attendees": "Partecipanti",
  "topics": "Argomenti",
  "agreements": "Accordi",
  "next_steps": "Prossimi passi",
  "description": "Descrizione",
  "tradefair": "Modalità fiera",
  "quick_capture": "Cattura rapida lead",
  "captured_leads": "Lead catturati",
  "save_next": "Salva e prossimo lead",
  "today": "Oggi",
  "my_only": "Solo i miei",
  "all_team": "Tutto il team",
  "mark_done": "Segna come fatto",
  "lead_saved": "Lead salvato",
  "samples": "Campioni e artwork",
  "samples_tab": "Ordini campione",
  "artworks": "Approvazioni artwork",
  "sample_number": "N° campione",
  "artwork_number": "N° artwork",
  "requested_date": "Richiesto il",
  "tracking_number": "N° tracciamento",
  "upload_pdf": "Carica PDF",
  "view_pdf": "Vedi PDF",
  "no_file": "Ancora nessun file",
  "contracts": "Contratti",
  "contract_number": "N° contratto",
  "start_date": "Inizio",
  "end_date": "Fine",
  "annual_value": "Valore annuo",
  "price_index": "Indice prezzi",
  "index_base_value": "Valore base dell'indice",
  "indexation_threshold": "Soglia di indicizzazione %",
  "indexation_clause": "Clausola di indicizzazione",
  "days_to_expiry": "Giorni alla scadenza",
  "expiring_soon": "In scadenza",
  "expired": "Scaduto",
  "forecast": "Forecast e obiettivi",
  "target": "Obiettivo",
  "actual": "Effettivo",
  "attainment": "Raggiungimento",
  "burndown": "Obiettivo vs. effettivo (cumulato)",
  "monthly_comparison": "Obiettivo vs. effettivo mensile",
  "edit_targets": "Modifica obiettivi",
  "all_reps": "Tutti i commerciali",
  "by_territory": "Per territorio",
  "site_match": "Abbinamento stabilimento",
  "suggest_site": "Suggerisci stabilimento di produzione",
  "best_press": "Migliore macchina",
  "match_missing": "Non coperto",
  "plants": "Stabilimenti e macchine",
  "presses": "Macchine da stampa",
  "technology": "Tecnologia",
  "max_colors": "Max colori",
  "web_width": "Larghezza banda (mm)",
  "add_plant": "Crea stabilimento",
  "add_press": "Aggiungi macchina",
  "location": "Sede",
  "send_email": "Invia via e-mail",
  "send_8d": "Invia report 8D",
  "download_8d": "PDF report 8D",
  "recipient": "Destinatario",
  "message": "Messaggio",
  "send": "Invia",
  "email_sent_ok": "E-mail inviata",
  "email_simulated": "E-mail simulata (SMTP non configurato)",
  "photos": "Foto e file",
  "upload_photo": "Carica file",
  "portal_users": "Accessi al portale",
  "add_portal_user": "Crea accesso al portale",
  "reports": "Report",
  "report_name": "Nome del report",
  "run_report": "Esegui",
  "save_report": "Salva report",
  "shared": "Condiviso con il team",
  "add_filter": "Aggiungi filtro",
  "field": "Campo",
  "operator": "Operatore",
  "value": "Valore",
  "export_excel": "Esporta Excel",
  "my_reports": "Report salvati",
  "columns": "Colonne",
  "locations": "Sedi",
  "site_type": "Tipo di sede",
  "country": "Paese",
  "map_view": "Mappa",
  "erp_number": "N° ERP locale",
  "timezone": "Fuso orario",
  "lat": "Latitudine",
  "lng": "Longitudine",
  "account_manager": "Account manager",
  "network": "Rete",
  "relationships": "Relazioni",
  "add_relationship": "Aggiungi relazione",
  "relationship_type": "Tipo di relazione",
  "volume_pct": "% del volume",
  "contract_ref": "Rif. contratto",
  "performance": "Performance",
  "otif": "OTIF",
  "on_time": "Puntuale",
  "in_full": "Completo",
  "fill_rate": "Fill Rate",
  "lead_time": "Rispetto dei tempi",
  "complaint_rate": "Reclami / 1000 ordini",
  "forecast_accuracy": "Accuratezza forecast",
  "share_of_wallet": "Share of Wallet",
  "dso": "DSO (giorni)",
  "health_score": "Health",
  "days_late": "Giorni di ritardo",
  "scorecard": "Scorecard cliente",
  "export_pdf": "Esporta PDF",
  "duplicates": "Duplicati",
  "merge": "Unisci",
  "link_as_network": "Collega come rete",
  "confidence": "Confidenza",
  "pick_survivor": "Scegli record sopravvissuto",
  "merged_ok": "Record uniti",
  "user_location_matrix": "Matrice utente-sede",
  "weekly_digest": "Riepilogo settimanale",
  "send_test": "Invia test a…",
  "send_now": "Invia ora a tutti i commerciali",
  "digest_enabled": "Invio automatico il lunedì alle 07:00",
  "preview": "Anteprima",
  "perm_groups": "Gruppi di permessi",
  "add_group": "Crea gruppo",
  "module_rights": "Diritti di modulo",
  "default_right": "Diritto predefinito",
  "margins_visible": "Margini visibili",
  "scoped_label": "Visibilità per sede",
  "orders_12m": "Ordini (12M)",
  "no_kpi_data": "Ancora nessuno storico ordini per questo cliente",
  "qbr_package": "Pacchetto QBR (PDF)",
  "current_indexes": "Valori indice attuali",
  "index_deviation": "Δ Indice",
  "index_alerts": "avvisi indice attivati",
  "renew": "Rinnova",
  "renew_contract": "Rinnova contratto",
  "renewed_from": "Rinnovato da",
  "duration_months": "Durata (mesi)",
  "new_start_date": "Nuovo inizio",
  "new_end_date": "Nuova fine",
  "contract_renewed": "Contratto rinnovato",
  "import_indexes": "Importa indici",
  "import_index_help": "Incolla CSV o carica un file. Formati: lungo (date, index_name, value) o largo (date, index-A, index-B, …). Separatore e formato data rilevati automaticamente (ISO / DE / mese).",
  "paste_csv": "Incolla dati CSV",
  "upload_file": "Carica file",
  "or_upload": "o carica file",
  "target_index": "Indice di destinazione (solo per file a valore singolo)",
  "any_column": "Rileva automaticamente",
  "import_result": "Importato",
  "rows_skipped": "saltato",
  "index_history": "Storico indici",
  "index_trend": "Trend dell'indice prezzi",
  "no_history_yet": "Ancora nessuno storico – modifica o importa valori",
  "last_12m": "12 mesi",
  "last_24m": "24 mesi",
  "last_36m": "36 mesi",
  "manual": "Inserimento manuale",
  "import": "Importa",
  "guide": "Guida",
  "guide_title": "Guida di Encasa CRM & SRM",
  "guide_subtitle": "Tutto per sfruttare al meglio la tua piattaforma CRM e SRM — modulo per modulo.",
  "guide_intro": "Scegli un modulo qui sotto per scoprire cosa fa, o riavvia il tour guidato.",
  "start_tour": "Avvia tour",
  "restart_tour": "Riavvia tour guidato",
  "tour_skip": "Salta tour",
  "tour_next": "Avanti",
  "tour_back": "Indietro",
  "tour_finish": "Fine",
  "tour_step": "Passo",
  "greeting_morning": "Buongiorno",
  "greeting_afternoon": "Buon pomeriggio",
  "greeting_evening": "Buonasera",
  "todays_overview": "Ecco il tuo business a colpo d'occhio oggi.",
  "tour_welcome_title": "Benvenuto in Encasa CRM & SRM",
  "tour_welcome_body": "Fai un rapido tour di 60 secondi delle aree principali. Puoi ripeterlo quando vuoi dalla pagina Guida.",
  "tour_nav_title": "Navigazione principale",
  "tour_nav_body": "Passa tra tutti i moduli — clienti, opportunità, offerte, reclami, contratti e altro.",
  "tour_search_title": "Ricerca globale",
  "tour_search_body": "Trova all'istante clienti, contatti, opportunità, offerte e reclami da qualsiasi punto.",
  "tour_new_title": "Crea record velocemente",
  "tour_new_body": "Usa il pulsante Nuovo per aggiungere qualsiasi tipo di record senza lasciare la pagina attuale.",
  "tour_notif_title": "Notifiche",
  "tour_notif_body": "Violazioni SLA, contratti in scadenza e promemoria di approvazione arrivano tutti qui.",
  "tour_done_title": "Tutto pronto!",
  "tour_done_body": "Apri la pagina Guida quando vuoi per un aiuto dettagliato su ogni modulo.",
  "guide_desc_dashboard": "Dashboard vendite, qualità e direzione con KPI live, pipeline, forecast e rischio abbandono.",
  "guide_desc_accounts": "Vista cliente a 360°: gerarchia, certificazioni, KPI, relazioni di rete ed export QBR.",
  "guide_desc_locations": "Gestisci stabilimenti/sedi con vista mappa e filtro per regione e tipo di sede.",
  "guide_desc_contacts": "Contatti con collegamenti multi-cliente e ruoli del buying center.",
  "guide_desc_leads": "Scoring dei lead e conversione con un clic in cliente, contatto e opportunità.",
  "guide_desc_opportunities": "Pipeline Kanban con drag & drop, forecast ponderato, avvisi di anzianità e abbinamento stabilimento.",
  "guide_desc_quotes": "Offerte per voci con prezzi a scaglioni, margini, versionamento ed export PDF.",
  "guide_desc_complaints": "Gestione reclami 8D con tracciamento SLA, escalation e registrazione costi.",
  "guide_desc_samples": "Ordini campione e approvazioni artwork con caricamento PDF reale e flusso di stati.",
  "guide_desc_contracts": "Contratti con clausole di indice prezzi, flusso di rinnovo e grafici di trend.",
  "guide_desc_activities": "Chiamate, riunioni, visite e attività con un calendario di team condiviso.",
  "guide_desc_reports": "Generatore di report con filtri, report salvati ed export Excel.",
  "guide_desc_forecast": "Obiettivi di territorio vs. effettivi con KPI di raggiungimento e grafici burndown.",
  "guide_desc_tradefair": "Cattura rapida dei lead ottimizzata per dispositivi mobili in fiera.",
  "guide_desc_admin": "Utenti, gruppi di permessi, liste, stabilimenti, duplicati e impostazioni del riepilogo.",
  "customer_forecast": "Forecast cliente",
  "select_account": "Seleziona cliente",
  "fiscal_year": "Anno fiscale",
  "scope": "Livello",
  "customer_level": "Livello cliente (nessun progetto)",
  "all_projects": "Tutti (aggregato)",
  "projects": "Progetti",
  "project": "Progetto",
  "new_project": "Nuovo progetto",
  "add_project": "Crea progetto",
  "project_name": "Nome del progetto",
  "link_opportunity": "Collega opportunità (opzionale)",
  "no_opp_link": "Nessuna opportunità",
  "delete_project": "Elimina progetto",
  "project_deleted": "Progetto eliminato",
  "project_created": "Progetto creato",
  "metric": "Metrica",
  "revenue": "Fatturato",
  "month": "Mese",
  "fc_revenue": "Forecast fatturato",
  "actual_revenue": "Fatturato effettivo",
  "fc_qty": "Forecast quantità",
  "actual_qty": "Quantità effettiva",
  "total_forecast": "Forecast totale",
  "total_actual": "Effettivo totale",
  "deviation": "Scostamento",
  "save_forecast": "Salva",
  "forecast_saved": "Forecast salvato",
  "forecast_vs_actual": "Forecast vs. effettivo",
  "import_excel": "Importa Excel",
  "download_template": "Modello",
  "import_done": "Righe importate",
  "aggregate_readonly": "La vista aggregata è in sola lettura — scegli un progetto o il livello cliente per modificare.",
  "guide_desc_customer_forecast": "Forecast mensile cliente e progetto vs. effettivo (fatturato + quantità) con Excel.",
  "autofill_actuals": "Recupera effettivi dagli ordini",
  "autofilled": "Mesi effettivi compilati",
  "no_autofill": "Nessun nuovo effettivo trovato",
  "group": "Gruppo",
  "group_rollup": "Riepilogo del gruppo",
  "members": "Membri",
  "fillers": "Co-packer / confezionatori",
  "global_cs": "Global Customer Service",
  "assign_global_cs": "Assegna responsabile CS globale",
  "cs_assigned": "Responsabile CS globale assegnato",
  "group_complaints": "Reclami del gruppo",
  "total_members": "Membri",
  "no_cs_owner": "Non assegnato",
  "open_pipeline": "Pipeline aperta",
  "top_customer_forecast": "Top clienti · Forecast vs. effettivo",
  "portal_quotes": "Offerte",
  "portal_artworks": "Approvazioni artwork",
  "approve": "Approva",
  "reject": "Richiedi revisione",
  "decision_saved": "Decisione salvata",
  "add_note": "Nota (opzionale)",
  "awaiting_decision": "In attesa della tua decisione",
  "no_quotes_portal": "Ancora nessuna offerta disponibile.",
  "no_artworks_portal": "Nessun artwork da revisionare.",
  "forecast_approvals": "Approvazioni forecast",
  "approval_status": "Approvazione",
  "submit_for_approval": "Invia per approvazione",
  "fc_approve": "Approva",
  "fc_reject": "Rifiuta",
  "reject_reason": "Motivo del rifiuto",
  "st_draft": "Bozza",
  "st_submitted": "In approvazione",
  "st_approved": "Approvato",
  "st_rejected": "Rifiutato",
  "st_none": "Non inviato",
  "no_pending_approvals": "Nessun forecast in attesa di approvazione.",
  "submitted_by": "Inviato da",
  "pending_approval_hint": "In approvazione (non ancora conteggiato come impegnato)",
  "approved_fc": "Approvato",
  "pending_fc": "In approvazione",
  "group_qbr": "QBR del gruppo (PDF)",
  "submitted_ok": "Inviato per approvazione",
  "approved_ok": "Forecast approvato",
  "rejected_ok": "Forecast rifiutato",
  "guide_desc_forecast_approvals": "Rivedi, approva o rifiuta i forecast cliente inviati dal team vendite.",
  "history": "Storico",
  "show_history": "Storico",
  "no_history": "Ancora nessuno storico.",
  "ev_submitted": "inviato",
  "ev_approved": "approvato",
  "ev_rejected": "rifiutato",
  "send_reminders": "Invia promemoria ora",
  "reminders_sent_msg": "Promemoria inviati",
  "lp_switch_normal": "Normale",
  "lp_switch_hero": "Modalità Hero",
  "lp_eyebrow": "CRM e SRM per produttori di imballaggi",
  "lp_title": "Vendite e acquisti su un'unica piattaforma.",
  "lp_desc": "Clienti, pipeline, offerte e qualità — più gestione fornitori, verifica bancaria a quattro occhi e approvvigionamento. Un'unica piattaforma per produttori di imballaggi: etichette, shrink sleeve, imballaggi flessibili e astucci pieghevoli.",
  "lp_cta": "Accedi a Encasa",
  "lp_f1_t": "Vendite e offerte",
  "lp_f1_d": "Traccia la pipeline, genera offerte PDF e prevedi il fatturato.",
  "lp_f2_t": "Acquisti e fornitori",
  "lp_f2_d": "Anagrafica fornitori, controllo bancario a quattro occhi e approvvigionamento.",
  "lp_f3_t": "Qualità e KPI",
  "lp_f3_d": "Reclami 8D, scorecard, forecast e report QBR.",
  "lp_nav_signin": "Accedi",
  "lp_features_title": "Tutto per vendite e acquisti",
  "lp_features_sub": "Un'unica piattaforma per l'intero ciclo commerciale — dal lead alla consegna, dal fornitore alla fattura.",
  "lp_f4_t": "Contratti e IA",
  "lp_f4_d": "Estrazione contratti con IA, gestione scadenze e clausole di indice prezzi.",
  "lp_f5_t": "Analytics e forecast",
  "lp_f5_d": "Dashboard live, forecast clienti e KPI di gestione.",
  "lp_f6_t": "Portali e collaborazione",
  "lp_f6_d": "Portali clienti e fornitori con accesso sicuro e tracciato.",
  "lp_signin_card_title": "Bentornato",
  "lp_explore": "Scopri le funzioni",
  "lp_stat1_l": "Cliente 360°",
  "lp_stat2_l": "Lingue",
  "lp_stat3_l": "Processo qualità",
  "lp_stat4_l": "Gestione fornitori",
  "hero_eyebrow": "La straordinaria squadra CRM",
  "hero_tagline": "Salva la tua pipeline. Sconfiggi il caos.",
  "hero_desc": "Sette eroi. Una missione: annientare l'abbandono, polverizzare gli SLA e salvare ogni trattativa sull'orlo del baratro.",
  "hero_cta": "Unisciti alla Force",
  "hero_p1_t": "Potenza di pipeline",
  "hero_p1_d": "Attraversa il tuo funnel di vendita a velocità sovrumana.",
  "hero_p2_t": "Distruttore di reclami",
  "hero_p2_d": "Neutralizza le minacce alla qualità prima che degenerino.",
  "hero_p3_t": "Visione del forecast",
  "hero_p3_d": "Prevedi il futuro del fatturato di ogni cliente.",
  "hero_meet": "Conosci la squadra",
  "visit_notes": "Note di visita",
  "vn_record": "Registra nota",
  "vn_recording": "Registrazione…",
  "vn_stop": "Ferma registrazione",
  "vn_transcribing": "Trascrizione…",
  "vn_analyzing": "Analisi con IA…",
  "vn_transcript": "Trascrizione",
  "vn_edit_transcript": "Rivedi e modifica la trascrizione prima di salvare (il dettato dei nomi di prodotto può essere impreciso).",
  "vn_analyze_save": "Analizza e salva",
  "vn_ai_summarize": "Riassumi con IA",
  "vn_ai_summary_title": "Riassunto IA (Assistente rapporto di visita)",
  "vn_ai_apply": "Applica",
  "vn_language": "Lingua",
  "vn_auto": "Rilevamento automatico",
  "vn_manual_entry": "Scrivi manualmente",
  "vn_upload_email": "Carica e-mail",
  "vn_manual_text_ph": "Scrivi qui la tua nota di visita…",
  "vn_source": "Origine",
  "vn_source_voice": "Voce",
  "vn_source_email": "E-mail",
  "vn_source_manual": "Manuale",
  "vn_risk": "Classificazione",
  "vn_risk_green": "Normale",
  "vn_risk_yellow": "Osserva",
  "vn_risk_orange": "Rischio",
  "vn_risk_red": "Escalation",
  "vn_partner": "Interlocutore e ruolo",
  "vn_topics": "Argomenti trattati",
  "vn_agreements": "Accordi / punti aperti",
  "vn_competitors": "Concorrenti menzionati",
  "vn_pricing": "Temi di prezzo / condizioni",
  "vn_next_steps": "Prossimi passi",
  "vn_triggers": "Argomenti trigger",
  "vn_reason": "Motivazione",
  "vn_override": "Correggi classificazione",
  "vn_override_reason": "Motivo della correzione (obbligatorio)",
  "vn_linked_opps": "Opportunità collegate",
  "vn_suggested_tasks": "Attività suggerite",
  "vn_create_tasks": "Crea attività selezionate",
  "vn_tasks_created": "Attività create",
  "vn_assignee": "Responsabile",
  "vn_no_notes": "Ancora nessuna nota di visita.",
  "vn_filter_all_sources": "Tutte le origini",
  "vn_filter_all_risks": "Tutte le classificazioni",
  "vn_search_ph": "Cerca nelle note… (es. quando si è parlato di prezzo)",
  "vn_from": "Da",
  "vn_to": "A",
  "vn_creator": "Creatore",
  "vn_all_creators": "Tutti i creatori",
  "vn_saved": "Nota salvata",
  "vn_show_transcript": "Mostra trascrizione",
  "vn_hide_transcript": "Nascondi trascrizione",
  "vn_mic_error": "Microfono non disponibile. Usa l'inserimento manuale o il caricamento e-mail.",
  "vn_reanalyze": "Rianalizza",
  "vn_corrected": "corretto",
  "vn_new_note": "Nuova nota",
  "vn_who": "Chi",
  "vn_what": "Cosa",
  "vn_due": "Entro quando",
  "vn_record_hint": "Tocca per dettare la tua nota subito dopo la riunione.",
  "vn_task_subject": "Attività",
  "vn_add_task": "Aggiungi attività",
  "escalation": "Escalation",
  "escalation_help": "Chi riceve gli avvisi di rischio rosso e il riepilogo settimanale dei rischi.",
  "escalation_saved": "Destinatari salvati",
  "sla_rules": "Regole SLA",
  "sla_saved": "Regole SLA salvate",
  "saving": "Salvataggio…",
  "hours": "ore",
  "days": "giorni",
  "sla_help": "Configura le soglie di livello di servizio che attivano promemoria ed escalation automatici nel CRM.",
  "sla_complaint_ack_hours": "Conferma del reclamo",
  "sla_complaint_ack_hours_desc": "Ore entro cui un nuovo reclamo viene escalato alla direzione se non confermato.",
  "sla_artwork_reminder_days": "Promemoria approvazione artwork",
  "sla_artwork_reminder_days_desc": "Giorni in cui un artwork inviato può attendere l'approvazione del cliente prima di sollecitare il responsabile.",
  "sla_contract_renewal_days": "Finestra di rinnovo contratto",
  "sla_contract_renewal_days_desc": "Giorni prima della scadenza di un contratto in cui iniziano i promemoria di rinnovo.",
  "orgchart_tab": "Organigramma",
  "orgchart_title": "Mappa del buying center",
  "orgchart_subtitle": "Contatti ordinati per influenza decisionale.",
  "orgchart_tier_decision": "Decisione",
  "orgchart_tier_influence": "Influenza e supporto",
  "orgchart_tier_operational": "Operativo / accesso",
  "orgchart_tier_empty": "Nessun contatto in questo livello",
  "orgchart_no_role": "Senza ruolo",
  "orgchart_empty": "Ancora nessun contatto — aggiungi contatti per vedere la mappa del buying center.",
  "orgchart_show_all": "Mostra tutti",
  "role_decision_maker": "Decision Maker",
  "role_champion": "Champion",
  "role_influencer": "Influencer",
  "role_gatekeeper": "Gatekeeper",
  "role_user": "User",
  "guide_desc_visit_notes": "Note di visita con IA: detta o carica e-mail, ottieni riepiloghi strutturati e una classificazione del rischio a 4 livelli.",
  "ai_contract_analysis": "Analisi contratto con IA",
  "contract_summary": "Riepilogo",
  "contract_deviations": "Scostamenti vs. dati CRM",
  "no_deviations": "Nessuno scostamento rilevato.",
  "contract_value": "Valore del contratto",
  "crm_value": "Valore CRM",
  "deviation_match": "Corrisponde",
  "deviation_deviation": "Scostamento",
  "deviation_unknown": "Sconosciuto",
  "severity_critical": "Critico",
  "severity_warning": "Avviso",
  "severity_info": "Info",
  "extracted_terms": "Dati estratti dal contratto",
  "contract_parties": "Parti",
  "contract_term": "Durata",
  "notice_period": "Termine di preavviso",
  "auto_renewal": "Rinnovo automatico",
  "pricing_conditions": "Prezzi e condizioni",
  "volume_minimum": "Volume / acquisto minimo",
  "liability_warranty": "Responsabilità e garanzia",
  "price_index_clauses": "Clausole di indice prezzi",
  "upload_contract_doc": "Carica contratto (PDF/DOCX)",
  "analyzing": "Analisi…",
  "analyzing_hint": "Estrazione dei dati con IA — può richiedere fino a 30 secondi.",
  "only_pdf_docx": "Solo PDF o DOCX",
  "no_contract_docs": "Ancora nessun documento contrattuale caricato.",
  "deviations_short": "scostamenti",
  "ok": "OK",
  "pages": "pagine",
  "paragraphs": "paragrafi",
  "ref_page": "pag.",
  "ref_paragraph": "par.",
  "months": "mesi",
  "yes": "Sì",
  "no": "No",
  "extraction_done": "Estrazione con IA completata",
  "extraction_failed": "Estrazione con IA fallita",
  "confirm_delete_doc": "Eliminare questo documento?",
  "deleted": "Eliminato",
  "view_original": "Vedi originale",
  "reextract": "Rianalizza",
  "back": "Indietro",
  "contract_deadlines": "Scadenze contratti",
  "contract_deadlines_subtitle": "Termini di preavviso, rinnovi e scadenze — basati sui dati estratti dall'IA.",
  "refresh": "Aggiorna",
  "urgency": "Urgenza",
  "urgency_notice_missed": "Preavviso mancato",
  "urgency_notice_soon": "Preavviso a breve",
  "urgency_expired": "Scaduto",
  "urgency_expiring_soon": "In scadenza",
  "urgency_none": "OK",
  "notice_deadline": "Data di preavviso",
  "with_ai_analysis": "Con analisi IA",
  "no_deadlines": "Nessun contratto aperto.",
  "no_notice_detected": "Nessun termine di preavviso rilevato",
  "upload_for_notice": "Carica contratto",
  "contract_data": "Dati del contratto",
  "documents": "Documenti",
  "account_analysis": "Analisi cliente",
  "ai_analysis": "Analisi cliente con IA",
  "wallet_share_tab": "Stabilimento e Wallet Share",
  "last_generated": "Generato l'ultima volta",
  "generate_now": "Genera ora",
  "update_now": "Aggiorna ora",
  "ai_never_run": "Nessuna analisi ancora generata.",
  "generating": "Generazione analisi…",
  "ai_trend": "Evoluzione del trend",
  "ai_sentiment": "Sentiment nel tempo",
  "ai_stakeholders": "Analisi del potere degli stakeholder",
  "ai_wallet": "Evoluzione del Wallet Share",
  "ai_risks_opps": "Fattori di rischio e opportunità",
  "ai_recommendations": "Raccomandazioni",
  "ai_direction": "Direzione",
  "dir_growing": "in crescita",
  "dir_stable": "stabile",
  "dir_declining": "in calo",
  "ai_notable_jumps": "Salti significativi",
  "ai_no_data": "Ancora nessun dato per questa sezione.",
  "ai_role": "Ruolo / influenza",
  "ai_stance": "Atteggiamento verso di noi",
  "ai_flag": "Indicatore di cambiamento",
  "risk_label": "Rischio",
  "chance_label": "Opportunità",
  "priority_short": "Prio",
  "ext_research": "Ricerca esterna",
  "ext_research_sub": "Fonti pubbliche · non verificato",
  "ext_update": "Aggiorna ricerca",
  "ext_never": "Ancora nessuna ricerca esterna.",
  "ext_researching": "Ricerca di fonti pubbliche…",
  "ext_news": "Notizie sull'azienda",
  "ext_financials": "Situazione finanziaria",
  "ext_strategy": "Direzione strategica",
  "ext_market_comp": "Concorrenti di mercato del cliente",
  "ext_contact_check": "Verifica dei contatti",
  "ext_no_info": "Nessuna informazione pubblica rilevante trovata.",
  "ext_unverified": "non verificato · fonte pubblica",
  "ext_source": "Fonte",
  "ext_no_date": "senza data",
  "internal_verified": "verificato · registrazione propria",
  "ws_plant_supply": "Fornitura stabilimento → cliente",
  "ws_add_supply": "Aggiungi fornitura",
  "ws_plant": "Stabilimento",
  "ws_period": "Periodo",
  "ws_period_month": "Mensile",
  "ws_period_quarter": "Trimestrale",
  "ws_qty": "Quantità",
  "ws_unit": "Unità",
  "ws_revenue": "Fatturato (EUR)",
  "ws_wallet": "Wallet Share (livello cliente)",
  "ws_add_wallet": "Aggiungi voce Wallet Share",
  "ws_category": "Categoria",
  "ws_budget": "Budget/fabbisogno totale (EUR)",
  "ws_our_eur": "La nostra quota (EUR)",
  "ws_our_pct": "La nostra quota %",
  "ws_comp_pct": "Quota concorrenza %",
  "ws_total_pct": "Totale %",
  "ws_competitors": "Concorrenti",
  "ws_comp_name": "Concorrente",
  "ws_comp_share": "Quota %",
  "ws_comp_source": "Fonte",
  "ws_add_competitor": "Aggiungi concorrente",
  "ws_over100": "La somma delle quote supera il 100% — controlla.",
  "ws_stale": "I dati Wallet Share hanno più di 6 mesi — aggiornali.",
  "ws_trend": "Wallet Share nel tempo",
  "ws_no_supply": "Ancora nessuna fornitura di stabilimento registrata.",
  "ws_no_wallet": "Ancora nessuna voce Wallet Share.",
  "ws_notes": "Note / fonte",
  "ws_change_history": "Storico modifiche",
  "ws_saved": "Salvato",
  "ws_deleted": "Eliminato",
  "plant_view": "Vista stabilimento",
  "plant_view_sub": "Quali clienti rifornisce ogni stabilimento",
  "pv_customers": "Clienti",
  "pv_total_qty": "Quantità totale",
  "pv_total_revenue": "Fatturato totale",
  "pv_no_data": "Ancora nessun dato di fornitura per questo stabilimento.",
  "pv_select_plant": "Tutti gli stabilimenti",
  "guide_desc_plant_view": "Vista aggregata dello stabilimento: quali clienti rifornisce ogni stabilimento e con quale volume.",
  "analysis_pdf": "PDF di analisi (QBR)",
  "access_denied_intel": "Solo vendite, KAM e direzione possono vedere questi dati.",
  "language": "Lingua",
  "lang_en": "Inglese",
  "lang_de": "Tedesco",
  "lang_es": "Spagnolo",
  "lang_pt": "Portoghese",
  "lang_it": "Italiano",
  "translate": "Traduci",
  "translating": "Traduzione…",
  "show_original": "Mostra originale",
  "translated_hint": "Traduzione IA — i termini tecnici (Wallet Share, OTIF, SLA…) restano in inglese.",
  "faq": "FAQ",
  "faq_title": "Domande frequenti",
  "faq_subtitle": "Risposte rapide alle domande più comuni su Encasa CRM & SRM.",
  "faq_intro": "Non trovi quello che cerchi? Riavvia il tour guidato o apri una guida di modulo qui sopra.",
  "guide_faq_card": "FAQ",
  "guide_desc_faq": "Risposte alle domande frequenti su ruoli, contratti, forecast, lingue e funzioni IA.",
  "guide_getting_started": "Per iniziare",
  "guide_gs_intro": "Quattro passi rapidi per essere produttivo dal primo giorno.",
  "guide_gs_1_t": "1 · Trova tutto velocemente",
  "guide_gs_1_d": "Usa la barra di ricerca globale in alto per saltare a qualsiasi cliente, contatto, opportunità, offerta o reclamo.",
  "guide_gs_2_t": "2 · Lavora sui tuoi clienti",
  "guide_gs_2_d": "Apri un cliente per la vista a 360° — gerarchia, KPI, contratti, note di visita e analisi IA in un unico posto.",
  "guide_gs_3_t": "3 · Anticipa le scadenze",
  "guide_gs_3_d": "La campanella delle notifiche e la pagina Scadenze contratti mostrano violazioni SLA, rinnovi e termini di preavviso.",
  "guide_gs_4_t": "4 · Lavora nella tua lingua",
  "guide_gs_4_d": "Cambia l'interfaccia tra IT/EN/DE/ES/PT quando vuoi tramite il selettore di lingua nella barra superiore.",
  "guide_more_help": "Serve altro aiuto?",
  "guide_open_faq": "Apri FAQ",
  "guide_desc_my_access": "Consulta il tuo ruolo, i permessi di campo, i clienti visibili e le sostituzioni attive.",
  "faq_q1": "Come funzionano ruoli e permessi?",
  "faq_a1": "Ogni utente ha un ruolo (admin, responsabile vendite, commerciale, servizio clienti, sola lettura) più un profilo di permessi opzionale. Questi decidono quali clienti vedi, se vedi i dati commerciali (fatturato, margini, Wallet Share) e se puoi modificare. Controlla i tuoi diritti nella pagina «I miei diritti».",
  "faq_q2": "Devo lavorare sul cliente di un collega. Come ottengo l'accesso?",
  "faq_a2": "Un admin o responsabile vendite può concederti un accesso temporaneo di sostituzione (es. per ferie) o un'eccezione una tantum in Amministrazione → Accesso e sostituzione. Le autorizzazioni hanno una data di inizio/fine e scadono automaticamente.",
  "faq_q3": "Come funziona l'analisi dei contratti con IA?",
  "faq_a3": "Apri un contratto, vai alla scheda Documenti e carica un PDF o DOCX. GPT-4o estrae durata, termine di preavviso, rinnovo automatico, prezzi e clausole di indice — ognuno con riferimento di pagina/paragrafo — e segnala gli scostamenti rispetto ai tuoi dati CRM. Non modifica mai i tuoi dati; li riporta soltanto.",
  "faq_q4": "Cosa significano le urgenze delle scadenze contrattuali?",
  "faq_a4": "«Preavviso mancato» = il termine di disdetta è passato; «Preavviso a breve» = entro 30 giorni; «In scadenza» = termina entro 90 giorni; «Scaduto» = data di fine superata. Si basano sul preavviso estratto dall'IA, quindi carica il documento del contratto per attivarle.",
  "faq_q5": "Come funzionano i forecast e le approvazioni?",
  "faq_a5": "Inserisci il forecast mensile vs. effettivo per cliente e progetto. I commerciali inviano un forecast dell'anno fiscale per l'approvazione; i responsabili vendite lo approvano o rifiutano nella coda Approvazioni forecast. I forecast approvati contano come impegnati; modificarli li riporta in bozza per una nuova approvazione.",
  "faq_q6": "Quali lingue sono supportate e come cambio?",
  "faq_a6": "L'interfaccia è disponibile in italiano, inglese, tedesco, spagnolo e portoghese. Usa il selettore di lingua nella barra superiore — la tua scelta viene memorizzata su questo dispositivo. Termini tecnici come Wallet Share, OTIF, SLA e QBR restano volutamente in inglese.",
  "faq_q7": "Posso tradurre una nota o un riepilogo scritto in un'altra lingua?",
  "faq_a7": "Sì. I riepiloghi generati dall'IA (analisi contratto, analisi cliente, note di visita) mostrano un link «Traduci» che mostra il testo nella lingua attuale dell'interfaccia su richiesta e permette di tornare all'originale.",
  "faq_q8": "Come funzionano reclami, 8D e tracciamento SLA?",
  "faq_a8": "I reclami ricevono un numero REK automatico e un SLA di conferma. Se non confermati in tempo, escalano alla direzione. Registra il report 8D (D1–D8) e i costi, poi invia il PDF 8D al cliente direttamente dal reclamo via e-mail.",
  "faq_q9": "Come esporto i dati?",
  "faq_a9": "La maggior parte degli elenchi offre esportazione/importazione CSV. Il generatore di report esporta in Excel (XLSX). Scorecard, pacchetti QBR e l'analisi cliente si esportano in PDF dalle rispettive schermate.",
  "faq_q10": "Cosa significano i livelli di rischio delle note di visita?",
  "faq_a10": "Dopo aver dettato o caricato una nota, l'IA la classifica come Normale (verde), Osserva (giallo), Rischio (arancione) o Escalation (rosso). L'arancione notifica il responsabile del cliente; il rosso avvisa anche i destinatari dell'escalation. Puoi correggere la classificazione con una motivazione obbligatoria.",
  "translations_tab": "Traduzioni",
  "tr_help": "Sovrascrivi qualsiasi testo dell'interfaccia per lingua. Un valore vuoto ripristina la traduzione integrata. Le modifiche si applicano immediatamente a tutti gli utenti.",
  "tr_no_overrides": "Ancora nessun override — cerca una chiave qui sopra per personalizzare un testo.",
  "guide_manual": "Manuale",
  "guide_search_ph": "Cerca una funzione…",
  "guide_update_btn": "Aggiorna manuale",
  "guide_updating": "Aggiornamento…",
  "guide_last_updated": "Ultimo aggiornamento",
  "guide_up_to_date": "Aggiornato",
  "guide_generating": "Il manuale è in fase di generazione — i contenuti miglioreranno a breve.",
  "guide_sec_purpose": "A cosa serve?",
  "guide_sec_steps": "Passo dopo passo",
  "guide_sec_tips": "Consigli",
  "guide_sec_roles": "Ruoli e permessi",
  "guide_select_prompt": "Seleziona un tema a sinistra per leggere la guida.",
  "guide_no_results": "Nessuna funzione trovata.",
  "guide_ai_badge": "Generato da IA",
  "guide_all_topics": "Tutti i temi",
  "guide_whats_new": "Novità",
  "guide_new_badge": "Nuovo",
  "guide_whats_new_empty": "Ancora nessuna novità."
};
export default dict;
